<template>
  <div class="home">
    <Sidebar :isMobile="isMobile" />
    <div class="content" ref="homeContent">
      <router-view :key="$route.fullPath" :isMobile="isMobile"></router-view>
    </div>
    <ModalCentral :config="modalConfig" />
  </div>
</template>

<script>
import Sidebar from "../components/General/Sidebar";
import ModalCentral from "../components/General/ModalCentral";

export default {
  name: 'home',
  components: {
    Sidebar,
    ModalCentral
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')),

      isMobile: false,
      isLoading: null,

      modalConfig: {
        visible: false,
        showSidebar: !this.isMobile,
        content: 'simulation'
      }
    }
  },
  mounted() {
    if(localStorage.hasOwnProperty('versionUpdated') && localStorage.getItem('versionUpdated')) {
      this.modalConfig.visible = false;
      localStorage.removeItem('versionUpdated');
    }

    if(window.Tawk_API && window.Tawk_API.setAttributes) {
      this.setTawkToUser(this.user);
    }
    else {
      const scope = this;
      window.Tawk_API.onLoad = function () {
        scope.setTawkToUser(scope.user);
      };
    }
    window.onbeforeprint = function () {
      if (window.Tawk_API && typeof window.Tawk_API.hideWidget === 'function') {
        window.Tawk_API.hideWidget();
        setTimeout(function() {
          window.Tawk_API.showWidget();
        }, 1000);
      }
    };
    // this.$intercom.update({
    //   user_id: this.user.person.id,
    //   name: this.user.person.name,
    //   email: this.user.person.email,
    //   "client_id": this.user.person.client.id,
    //   "client_name": this.user.person.client.name
    // });

    this.$nextTick(function() {
      window.addEventListener('resize', this.getWindowDimensions);
      this.getWindowDimensions();
    });

    this.eventBus.$on('IS_LOADING', (isLoading) => {
      if(isLoading) {
        if(typeof this.isLoading != 'undefined' && this.isLoading != null) {
          return;
        }
        this.isLoading = this.$loading.show({
          container: this.$refs.homeContent,
          canCancel: false,
          isFullPage: false,
          color: '#21A7F0',
          backgroundColor: '#212C3B'
        });
      } else {
        if(typeof this.isLoading != 'undefined' && this.isLoading != null) {
          this.isLoading.hide();
          this.isLoading = null;
        }
      }
    });

    this.eventBus.$on('CLOSE_MODAL', () => {
      this.modalConfig.visible = false;
    });
  },
  methods: {
    getWindowDimensions() {
      if(screen.width <= 767 && !this.isMobile) {
        this.isMobile = true;
        this.modalConfig.showSidebar = false;
      } else if(screen.width >= 768 && this.isMobile) {
        this.isMobile = false;
        this.modalConfig.showSidebar = true;
      }
    },

    setTawkToUser(user) {
      try {
        window.Tawk_API.setAttributes({
          id: user.person.id,
          name: user.person.name,
          email: user.person.email,
          clientId: user.person.client.id,
          clientName: user.person.client.name
          // 'hash': user.emailHmac
        }, function(error){
          if(error) {
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error', error);
          }
        });
      } catch(err) {
        console.log('TawkTo Error', err);
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowDimensions);
  }
}
</script>

<style scoped lang="scss">
  .home {
    display: flex;
    overflow: hidden;
    min-height: 100vh;

    .content {
      flex: 1;
      background-color: #f0f2f8;
      height: 100vh;
      overflow: scroll;
      overflow-x: hidden;
    }
  }

  @media (max-width: 767px) {
    .home {
      flex-flow: column wrap;
    }

    .content {
      margin-top: 86px;
      height: calc(100vh - 86px) !important;
    }
  }

  @media print {
    aside {
      display: none;
    }

    .content {
      background-color: #ffffff !important;
      height: auto !important;
    }
  }
</style>
